import React from "react";

const FullWidthSection = ({
  children,
  backgroundColor = "transparent",
  padding = "py-6",
  classProvided = "",
  bgImmage,
}) => (
  <div
    className={`relative w-screen ${backgroundColor} ` + classProvided}
    style={{
      left: "50%",
      right: "50%",
      marginLeft: "-50vw",
      marginRight: "-50vw",
      backgroundImage: bgImmage !== undefined ? `url(${bgImmage})` : "",
      backgroundRepeat: bgImmage !== undefined ? "no-repeat" : "",
      backgroundPosition: bgImmage !== undefined ? "right 3% bottom 7%" : "",
      backgroundSize: bgImmage !== undefined ? "160px 160px" : "",
    }}
  >
    <div className={`container ${padding}`}>{children}</div>
  </div>
);

export default FullWidthSection;
